import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./login.css";
// import  Loading from '../../components/Loading/loading'
import { useDispatch, useSelector } from "react-redux";
import { clearError, loadUser, login } from '../redux/actions/userAction'
import { FiLock } from "react-icons/fi";
import { MdEmail } from "react-icons/md";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { Helmet } from "react-helmet";

const Login = () => {
    const { error, loading, isAuthenticated } = useSelector((state) => state.user)
    const [loginEmail, setloginEmail] = useState();
    const [loginPassword, setloginPassword] = useState();
    const [isEye, setIsEye] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate()
    // const redirect = location.search ? location.search.split("=")[1] : "/account";

    const loginHandler = (e) => {
        e.preventDefault();
        console.log("login", loginEmail, loginPassword);
        dispatch(login(loginEmail, loginPassword))
    };

    useEffect(() => {
        if (error) {
            alert(error)
            dispatch(clearError())
        }
        if (!loading) {
            if (!isAuthenticated) {
                console.log(loading, isAuthenticated)
                navigate("/login");
            }
        }
        if (isAuthenticated === true) {
            console.log('log...,', isAuthenticated)
            navigate("/");
            // window.location = '/'
        }
         

    }, [dispatch, error, isAuthenticated]);

    // if (!loading) {
    //     if (!isAuthenticated) {
    //         console.log(loading, isAuthenticated)
    //         navigate("/login");
    //     }
    // }

    // if (isAuthenticated) {
    //     navigate("/");
    // }
    

    const handleEye = (e) => {
        e.preventDefault();
        setIsEye(!isEye)
    }

    return (
        <Fragment>
            <Helmet title={'Login'} />
            {

                loading ? (<div className="loading">Loading...</div>) : (
                    <div className="loginContainer">
                        <div className="imgBox">
                            {/* <img src={require('../../images/login.avif')} alt="" /> */}
                        </div>
                        <div>
                            <div className="formBox">
                                <h2>Login</h2>
                                <form action="" onSubmit={loginHandler}>
                                    <div className="inputItem">
                                        <MdEmail />
                                        <input type="email" className="logInpBtn" placeholder="name" value={loginEmail} onChange={(e) => setloginEmail(e.target.value)} />
                                    </div>
                                    <div className="inputItem">
                                        <FiLock />
                                        <input
                                            type={isEye ? "password" : "text"}
                                            className="logInpBtn"
                                            placeholder="password"
                                            value={loginPassword} onChange={(e) => setloginPassword(e.target.value)}
                                        />
                                        <button onClick={handleEye} className="eye-btn">
                                            {isEye ? <FaRegEyeSlash size="16" /> : <FaRegEye size="16" />}
                                        </button>
                                    </div>
                                    <div className="btnBox">
                                        <input type="submit" className="subBtn" placeholder="name" />
                                    </div>
                                </form>
                                <div className="regBox">
                                    {/* <p>I m New </p> */}
                                    {/* <Link to={"/forget/password"}>Forget Password</Link> */}
                                    {/* <Link className="submintBt" to={"/register"}>
                  Sign up
                </Link> */}

                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </Fragment>
    );
};

export default Login;
